'use strict';

function FareAnalysisPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FareAnalysisPanelController',
    template: require('../templates/fare-analysis-panel.html')
  };
}
FareAnalysisPanelDirective.$inject = [];
module.exports = FareAnalysisPanelDirective;